import { BlockTitle } from "@blocks/Blocks";
import { ComponentPropsWithTitle } from "@pages/Keyword/templates/CampaignTemplate/types";
import Card from "@particles/card/Card";
import { CardVariations } from "@particles/card/utils/types";
import { cn } from "@util/helpers";

type ViewsProps = {
  /** data to display in the views section */
  views: ComponentPropsWithTitle;
  /** Additional class names for styling */
  className: string;
};

/**
 * Views articles that is displayed in VIEWS section
 * https://www.figma.com/design/QCEPjsj7Sdm5KqnY3ta5tq/TEMPLATES--WEB---APP-?node-id=1-12533&t=NMzsh6SczSQjIa80-4
 */
const Views = ({ views, className }: ViewsProps): React.ReactElement => {
  if (views.props.length === 0) {
    return <></>;
  }

  const firstArticleProps = views.props[0];
  const restArticleProps = views.props.slice(1);

  const variant: CardVariations = {
    title: {
      color: "text-gray-850",
      size: "text-lg",
      extraClass: "mt-4 mb-2 font-lct md:mt-0",
    },
    content: {
      width: "w-full",
      extraClass: "text-gray-850",
      blurb: {
        extraClass: "text-xs md:text-base !block",
      },
    },
    byline: {
      extraClass: "text-xs items-center font-public-sans mt-2",
    },
  };

  const mainArticlevariant: CardVariations = {
    content: {
      width: "w-full",
      extraClass: "text-start md:text-center text-gray-850",
      blurb: {
        extraClass: "pb-2 text-xs md:text-base !block",
      },
    },
    title: {
      color: "text-gray-850",
      size: "text-lg md:text-4xl",
      extraClass: "font-lct mb-2",
    },
    byline: {
      imageWidth: 32,
      imageHeight: 32,
      extraClass:
        "text-xs flex font-public-sans md:justify-center items-center mt-2",
    },
  };

  return (
    <div className={className} data-testid="views-component">
      <BlockTitle
        text={views.title.toUpperCase()}
        rootClassName="md:text-center text-lg md:text-3xl"
      />

      <div className="border-gray-175">
        <div className="md:border-b md:border-gray-175">
          <Card
            {...firstArticleProps}
            className="pt-4 md:py-4"
            variations={mainArticlevariant}
          />
        </div>

        <div className="mt-4 grid md:grid-cols-2 md:gap-4 md:divide-x">
          {restArticleProps.map((props, index: number) => {
            return (
              <Card
                className={cn(
                  "border-gray-17 border-t pb-4 md:grid-cols-1 md:border-t-0 md:pb-0",
                  { "md:pl-3": index !== 0 }
                )}
                {...props}
                variations={variant}
                key={index}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Views;
